<template>
    <div class="codics-admin-lottery-body">
        <div class="codics-admin-lottery-control" style="margin-bottom: 20px;">
            <el-select class="codics-admin-lottery-control-search" v-model="nowType" placeholder="请选择活动"
                @change="typeChange">
                <el-option v-for="item in typeOptions" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
            </el-select>
            <el-input class="codics-admin-lottery-control-search" style="width: 300px !important;"
                placeholder="请输入活动名称..." v-model="searchTxt" clearable @input="searchChange">
                <el-button style="padding: 0 0px 0 15px;margin-right: 0 !important;" slot="append" icon="el-icon-search"
                    @click="searchPage = 1; searchMax = 0; searchData = []; nowSearchTxt = searchTxt; getRecordsData();"></el-button>
            </el-input>
            <el-popconfirm :title="'您确定要删除当前选中的' + selectData.length + '条数据吗？'" @confirm="deleteLotteriesFuc">
                <el-button class="codics-admin-lottery-control-search iconfont" slot="reference" type="danger"
                    icon="el-icon-delete" plain>批量删除</el-button>
            </el-popconfirm>
        </div>
        <el-table stripe class="codics-admin-lottery-table" :data="searchTxt == '' ? lotteryData : searchData" border
            style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="40">
            </el-table-column>
            <el-table-column prop="id" label="ID" width="80">
            </el-table-column>
            <el-table-column prop="cid" label="活动" width="80">
            </el-table-column>
            <el-table-column prop="area.name" label="姓名" width="80">
            </el-table-column>
            <el-table-column prop="area.phone" label="手机号" width="110">
            </el-table-column>
            <el-table-column prop="area" label="地址" width="180" class-name="codics-admin-product-brand-table-dz">
                <template slot-scope="scope">
                    {{ scope.row.area == null ? '未填写' : (scope.row.area.province + '/' + scope.row.area.city + '/' +
                    scope.row.area.area + '/' +
                    scope.row.area.remark) }}
                </template>
            </el-table-column>
            <el-table-column prop="lottery.name" label="奖品" width="80">
            </el-table-column>
            <el-table-column prop="ctime" label="创建时间" width="200">
                <template slot-scope="scope">
                    {{ initTime(scope.row.ctime) }}
                </template>
            </el-table-column>
            <el-table-column prop="state" label="状态" width="80"
                :filters="[{ text: '待核销', value: 0 }, { text: '待发货', value: 1 }, { text: '已发货', value: 2 }, { text: '已冻结', value: 3 }]"
                :filter-method="stateFilter" filter-placement="bottom-end">
                <template slot-scope="scope">
                    <el-tag
                        :type="scope.row.state == 0 ? 'info' : (scope.row.state == 1 ? 'warning' : (scope.row.state == 2 ? 'success' : 'danger'))"
                        disable-transitions>{{ scope.row.state == 0 ? '待核销' : (scope.row.state == 1 ? '待发货' :
                        (scope.row.state == 2 ? '已发货' : '已冻结')) }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="type" label="物流" width="70">
            </el-table-column>
            <el-table-column prop="tid" label="单号" width="220">
            </el-table-column>
            <el-table-column align="right" label="操作" min-width="150">
                <template slot-scope="scope">
                    <el-button size="mini" v-show="scope.row.area != null && scope.row.state != 3"
                        @click="handleClick(scope);" style="margin-right: 10px;">{{ scope.row.state == 0 ? '核销' :
                        (scope.row.state == 1 ? '发货' :
                        '查询物流') }}</el-button>
                    <el-popconfirm title="您确定要删除当前数据吗？" @confirm="deleteLotteriesFuc([scope.row.id])">
                        <el-button size="mini" type="danger" slot="reference">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="codics-admin-lottery-table-page" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :current-page="searchTxt == '' ? currentPage : searchPage"
            :page-sizes="[10, 20, 30, 40]" :page-size="searchTxt == '' ? dataSize : searchSize"
            layout="total, sizes, prev, pager, next, jumper" :total="searchTxt == '' ? maxSize : searchMax">
        </el-pagination>
        <el-dialog title="填写发货信息" :visible.sync="fahuoDialog" width="80%">
            <el-form :model="fahuoForm">
                <el-form-item label="快递类型" :label-width="formLabelWidth">
                    <el-select v-model="fahuoForm.type" placeholder="请选择">
                        <el-option v-for="item in wuliuType" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-show="fahuoForm.type != 'wuxvwuliu'" label="快递单号" :label-width="formLabelWidth">
                    <el-input placeholder="请输入快递单号" v-model="fahuoForm.tid" clearable
                        :style="{ width: 'calc(100% - 50px)' }">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="fahuoRecordFuc">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import * as qiniu from 'qiniu-js';
import { listPrizes, addLottery, queryProduct, getQiNiuToken, allActives, deleteLotteries, updateLottery, listRecord4, hexRecord, fahuoRecord } from '@/api';
export default {
    data() {
        return {
            nowType: 0,
            searchTxt: '',
            addLotteryDialog: false,
            updateLotteryDialog: false,
            fahuoDialog:false,
            addForm: {
                cid: '',
                name: '',
                img: '',
                odds: 0,
                count: 0,
                state: '0'
            },
            updateForm: {
                cid: '',
                name: '',
                img: '',
                odds: 0,
                count: 0,
                state: '0'
            },
            qiNiuInfo: {
                token: ''
            },
            typeOptions: [
                {
                    id: 0,
                    name: '全部活动'
                }
            ],
            typeOptions1: [],
            formLabelWidth: '120px',
            searchBrand: '名称',
            currentPage: 1,
            searchPage: 1,
            tableData: [],
            selectData: [],
            multipleSelection: [],
            maxSize: 0,
            searchMax: 0,
            dataSize: 10,
            searchSize: 10,
            lotteryData: [],
            shopLoad: false,
            productOptions: [],
            addSelect: '',
            nowSearchTxt: '',
            wuliuType: [
                {
                    value: 'shunfeng',
                    label: '顺丰快递'
                },
                {
                    value: 'zhongtong',
                    label: '中通快递'
                },
                {
                    value: 'yuantong',
                    label: '圆通快递'
                },
                {
                    value: 'shentong',
                    label: '申通快递'
                },
                {
                    value: 'jtexpress',
                    label: '极兔快递'
                },
                {
                    value: 'yunda',
                    label: '韵达快递'
                },
                {
                    value: 'jd',
                    label: '京东快递'
                },
                {
                    value: 'ems',
                    label: '邮政快递'
                },
                {
                    value: 'wuxvwuliu',
                    label: '无需物流'
                }
            ],
            fahuoForm: {

            }
        }
    },
    mounted() {

        this.$emit('check-mem');

        this.getRecordsData();

        this.listActivesFuc();

        this.getTokenFuc();

    },
    methods: {
        handleClick(scope) { 

            switch (scope.row.state) { 

                case 0:

                    this.hexRecordFuc(scope);

                    break;

                case 1:

                    this.fahuoForm.id = scope.row.id;

                    this.fahuoDialog = true;

                    break;

            }

        },
        async fahuoRecordFuc() { 

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await fahuoRecord(this.fahuoForm);

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '订单核销成功！',
                    type: 'success'
                });

                setTimeout(() => {
                    window.location.reload();
                }, 300);

            } else {

                this.$message.error(data.message);

            }

        },
        async hexRecordFuc(scope) { 

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await hexRecord({id:scope.row.id});

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '订单核销成功！',
                    type: 'success'
                });

                setTimeout(() => {
                    window.location.reload();
                }, 300);

            } else {

                this.$message.error(data.message);

            }

        },
        initTime(str) {
            return dayjs(str).format('YYYY-MM-DD HH:mm:ss');
        },
        async listActivesFuc() {

            let data = await allActives();

            if (data.code == 200) {

                this.typeOptions = [...this.typeOptions, ...data.data];

                this.typeOptions1 = [...data.data];

            } else {

                this.$message.error(data.message);

            }

        },
        typeChange(a) {
            this.getRecordsData();
        },
        stateFilter(v, r, c) {

            return r.state === v;

        },
        async getTokenFuc() {
            let data = await getQiNiuToken();
            if (data.code == 200) {
                this.qiNiuInfo.token = data.uptoken;
            } else {
                this.$message.error(data.message);
            }
        },
        async getRecordsData() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await listRecord4({ id: this.nowType, key: this.nowSearchTxt, pge: this.searchTxt == '' ? this.currentPage : this.searchPage, psz: this.searchTxt == '' ? this.dataSize : this.searchSize });

            loading.close();

            if (data.code == 200) {

                if (this.nowSearchTxt == '') {

                    this.lotteryData = data.data;

                    this.maxSize = data.data1;

                } else {

                    this.searchData = data.data;

                    this.searchMax = data.data1;

                }

            } else {

                this.$message.error(data.message);

            }

        },
        handleSizeChange(val) {
            if (this.searchTxt == '') {
                this.dataSize = val;
            } else {
                this.searchSize = val;
            }
            this.getRecordsData();
        },
        handleCurrentChange(val) {
            if (this.searchTxt == '') {
                this.currentPage = val;
            } else {
                this.searchPage = val;
            }
            this.getRecordsData();
        },
        sexFilter(v, r, c) {

            return r.sex === v;

        },
        handleSubCat(value) {
            // 获取value值
            this.addForm.p = value.length == 0 ? 0 : value[value.length - 1];
            // 获取label 值
            // console.log(this.$refs["refSubCat"].getCheckedNodes()[0].label)
        },
        async queryProductData(query) {

            if (query !== '') {
                this.shopLoad = true;
                let data = await queryProduct({ key: query });
                this.shopLoad = false;
                if (data.code == 200) {

                    this.$message({
                        message: '查询商品成功！',
                        type: 'success'
                    });

                    this.productOptions = data.data;

                } else {

                    this.$message.error(data.message);

                    this.productOptions = [];

                }
            } else {
                this.productOptions = [];
            }

        },
        selectChange(key) {
            this.addForm.pid = key.id;
            this.addForm.name = key.name;
        },
        // 图片点击预览
        handlePictureCardPreview(file) {

        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        // 上传方法
        uploadFile(uploadInfo, a) {

            console.log(uploadInfo, a)

            this.addForm.img = 'huayuan/img/' + uploadInfo.file.name.replace(',', '');

            const _that = this;
            // 上传文件
            const observer = {
                next(res) {
                    // console.log('next: ', res)
                },
                error(err) {
                    // console.log(err)
                },
                complete(res) {
                    // console.log('complete: ', res)
                    console.log('11111111111111:', a)
                    if (a == null) {
                        _that.addForm.img = '/' + res.key;
                    } else {
                        _that.updateForm.img = '/' + res.key;
                    }
                }
            }
            const observable = qiniu.upload(uploadInfo.file, 'huayuan/img/' + uploadInfo.file.name, this.qiNiuInfo.token, {}, {

            })
            const subscription = observable.subscribe(observer) // 上传开始
            // console.log(subscription);
            // subscription.unsubscribe() // 上传取消
        },
        // 图片删除
        handleRemove() {
            this.addForm.img = '';
            this.updateForm.img = '';
        },
        clearSelect() {
            this.addForm.pid = '';
            this.addForm.count = 0;
        },
        async addLotteryFuc() {
            if (this.addForm.cid == null) {

                this.$message({
                    showClose: true,
                    message: '请先绑定相应的活动！',
                    type: 'warning'
                });

                return true;

            }
            if (this.addForm.name == '' || this.addForm.img == '') {

                this.$message({
                    showClose: true,
                    message: '请先选中合适的奖品并上传名称及图片！',
                    type: 'warning'
                });

                return true;

            }
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let data = await addLottery(this.addForm);
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '数据添加成功！',
                    type: 'success'
                });
                setTimeout(() => {
                    window.location.reload();
                }, 300);
            } else {
                this.$message.error(data.message);
            }
        },
        searchChange(a) {
            if (a == '') {
                this.searchPage = 1;
                this.searchData = [];
                this.searchMax = 0;
                this.searchSize = 10;
                this.nowSearchTxt = '';
            }
        },
        async deleteLotteriesFuc(t) {

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要删除的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await deleteLotteries({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: data.data + '条数据删除成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                this.$message.error(data.message);

            }

        },
        async updateLotteryFuc() {

            if (this.updateForm.name == '') {

                this.$message.error('活动名称不能为空！');

                return;

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await updateLottery(this.updateForm);

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '更新奖品成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                this.$message.error(data.message);

            }

        },
        handleEdit(row) {
            setTimeout(() => {
                this.$refs['fmUpload'].uploadFiles = [];
                this.$refs['fmUpload'].uploadFiles.push({
                    name: '',
                    percentage: '',
                    raw: '',
                    size: '',
                    status: '',
                    uid: new Date().getTime(),
                    url: "https://cdn.bosscaigou.com/" + row.img
                })
            }, 30);
        }
    }
}
</script>

<style>
/* 后台管理端主页 */
.codics-admin-lottery-body {
    height: fit-content;
    min-height: 100%;
    width: 100%;
    position: relative;
    float: left;
    background: #FFF;
    box-sizing: border-box;
    padding: 20px;
}

/* 后台管理页面主页 */
.codics-admin-lottery-control {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
}

/* 后台管理页面主页控制栏 */
.codics-admin-lottery-control-input {
    width: 200px !important;
    position: relative;
    float: left;
    margin-right: 20px;
    margin-bottom: 20px;
}

/* 后台管理页面控制栏搜索按钮 */
.codics-admin-lottery-control-search {
    position: relative;
    float: left;
    margin-left: 0px !important;
    margin-right: 20px !important;
}

/* 表格控件 */
.codics-admin-lottery-table {
    height: fit-content;
    width: 100% !important;
    position: relative;
    float: left;
    margin-bottom: 20px;
}

/* 表格分页控件 */
.codics-admin-lottery-table-page {
    position: relative;
    float: right;
    right: 0;
}




.codics-admin-lottery-upload .el-upload {
    display: var(--himgSize);
}
</style>